import { IS_ETA_UPLOADING_COUNTDOWN_ENABLED } from '@env';
import { millisecondToFormattedTime } from './time.helper';

export const BAD_NETWORK_SCORE = 6;
export const SLOW_NETWORK_THRESHOLD = 10 * 60 * 1000; // 10 minutes
export const INITIAL_MESSAGE_TIMEOUT = 10 * 1000; // 10 seconds

export function getAddToCartETAInfo(
  i18n: any,
  {
    eta,
    progress,
    networkScore,
    showInitialMessage = false,
  }: { eta?: number; progress?: number; networkScore?: number; showInitialMessage?: boolean },
) {
  let title;
  let description;

  if (typeof progress === 'number' && progress === 100) {
    title = i18n.t('modal-upload-to-cart:title-complete');
    description = i18n.t('modal-upload-to-cart:description-complete');
  } else if (showInitialMessage) {
    title = i18n.t('modal-upload-to-cart:title');
    description = i18n.t('modal-upload-to-cart:description');
  } else if (typeof networkScore === 'number' && networkScore < BAD_NETWORK_SCORE) {
    title = i18n.t('modal-upload-to-cart:title');
    description = i18n.t('modal-upload-to-cart:description-bad-network');
  } else if (IS_ETA_UPLOADING_COUNTDOWN_ENABLED === 'true' && typeof eta === 'number' && eta < SLOW_NETWORK_THRESHOLD) {
    const formattedEta = millisecondToFormattedTime(eta);
    const formattedEtaMinutesCount = formattedEta.minutes;
    const formattedEtaSecondsCount = Math.floor(formattedEta.seconds / 10) * 10;
    if (formattedEtaMinutesCount > 0) {
      if (formattedEtaSecondsCount > 0) {
        description = i18n.t('modal-upload-to-cart:eta-minutes-seconds', {
          minutes: i18n.t('modal-upload-to-cart:minutes', { count: formattedEtaMinutesCount }),
          seconds: i18n.t('modal-upload-to-cart:seconds', { count: formattedEtaSecondsCount }),
        });
      } else {
        description = i18n.t('modal-upload-to-cart:eta-minutes', {
          minutes: i18n.t('modal-upload-to-cart:minutes', { count: formattedEtaMinutesCount }),
          count: formattedEtaMinutesCount,
        });
      }
    } else {
      description = i18n.t('modal-upload-to-cart:eta-seconds', {
        seconds: i18n.t('modal-upload-to-cart:seconds', { count: formattedEtaSecondsCount }),
      });
    }
  } else if (typeof eta === 'number' && eta >= SLOW_NETWORK_THRESHOLD) {
    title = i18n.t('modal-upload-to-cart:title');
    description = i18n.t('modal-upload-to-cart:description-slow-network');
  } else {
    title = i18n.t('modal-upload-to-cart:title');
    description = i18n.t('modal-upload-to-cart:description');
  }

  return { title, description };
}
